/* Basics · sugerencias mientras escribes en cualquier buscador del sitio (QA 18-10-2026, B7).
   El "predictive search" del theme depende de un ajuste global (config/settings_data.json) que no se toca desde aquí;
   esto usa la misma API de Shopify (/search/suggest.json) y no carga nada hasta que alguien escribe. */
(function () {
  var MIN = 2, ESPERA = 180, LIMITE = 6;
  var css = '.bns{position:absolute;left:0;right:0;top:100%;z-index:30;margin-top:6px;background:#fff;color:#1a1b18;border:1px solid rgba(26,27,24,.15);border-radius:10px;box-shadow:0 12px 32px rgba(26,27,24,.16);overflow:hidden;text-align:left;font:400 15px/1.3 var(--font-body-family,inherit);letter-spacing:0;text-transform:none}' +
    '.bns[hidden]{display:none}.bns ul{list-style:none;margin:0;padding:6px 0}' +
    '.bns a{display:flex;align-items:center;gap:12px;min-height:56px;padding:6px 14px;color:inherit;text-decoration:none}' +
    '.bns a:hover,.bns a[aria-selected=true]{background:#fbf7f1}' +
    '.bns img{width:44px;height:44px;flex:none;object-fit:contain;border-radius:6px;background:#f4f4f1}' +
    '.bns b{display:block;font-weight:600;font-size:15px}.bns small{display:block;margin-top:2px;font-size:14px;color:#4a4b46}' +
    '.bns .bns-todo{justify-content:center;min-height:48px;border-top:1px solid rgba(26,27,24,.1);font-weight:600}' +
    '.bns p{margin:0;padding:14px;font-size:15px}';
  var estilo = false, seq = 0;

  function plata(v) { var n = Math.round(parseFloat(v) || 0); return '$' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
  function img(u) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=96'; }

  function armar(input) {
    if (input.dataset.bns) return; input.dataset.bns = '1';
    var form = input.form; if (!form) return;
    if (!estilo) { var s = document.createElement('style'); s.textContent = css; document.head.appendChild(s); estilo = true; }
    var caja = input.closest('.field') || input.parentElement;
    if (getComputedStyle(caja).position === 'static') caja.style.position = 'relative';
    var panel = document.createElement('div'), id = 'bns-' + Math.random().toString(36).slice(2, 8);
    panel.className = 'bns'; panel.id = id; panel.hidden = true; panel.setAttribute('role', 'listbox');
    caja.appendChild(panel);
    input.setAttribute('autocomplete', 'off'); input.setAttribute('aria-controls', id);
    input.setAttribute('aria-autocomplete', 'list'); input.setAttribute('aria-expanded', 'false');
    var t, activo = -1;
    function cerrar() { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); activo = -1; }
    function links() { return [].slice.call(panel.querySelectorAll('a')); }
    function marcar(i) { var l = links(); activo = (i + l.length) % l.length; l.forEach(function (a, k) { a.setAttribute('aria-selected', k === activo); }); if (l[activo]) l[activo].scrollIntoView({ block: 'nearest' }); }
    function buscar() {
      var q = input.value.trim(), mio = ++seq;
      if (q.length < MIN) { cerrar(); return; }
      var raiz = (window.theme && theme.routes && theme.routes.predictive_search_url) || '/search/suggest';
      fetch(raiz + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=' + LIMITE + '&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); }).then(function (d) {
          if (mio !== seq) return;
          var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          var todo = form.getAttribute('action') + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
          panel.innerHTML = ps.length ? '<ul>' + ps.map(function (p) {
            var precio = (p.price_min && p.price_max && p.price_min !== p.price_max ? 'Desde ' : '') + plata(p.price_min || p.price);
            return '<li><a role="option" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(img(p.image)) + '" alt="" loading="lazy" width="44" height="44">' : '') +
              '<span><b>' + esc(p.title) + '</b><small>' + precio + '</small></span></a></li>';
          }).join('') + '</ul><a class="bns-todo" role="option" href="' + esc(todo) + '">Ver todos los resultados</a>'
            : '<p>No encontramos productos para «' + esc(q) + '». Prueba con otra palabra.</p>';
          panel.hidden = false; input.setAttribute('aria-expanded', 'true'); activo = -1;
        }).catch(cerrar);
    }
    input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(buscar, ESPERA); });
    input.addEventListener('focus', function () { if (panel.innerHTML && input.value.trim().length >= MIN) { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); } });
    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); marcar(activo + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); marcar(activo - 1); }
      else if (e.key === 'Enter' && activo > -1) { e.preventDefault(); links()[activo].click(); }
      else if (e.key === 'Escape') { e.stopPropagation(); cerrar(); }
    });
    document.addEventListener('click', function (e) { if (!caja.contains(e.target)) cerrar(); });
    form.addEventListener('reset', cerrar);
  }

  function iniciar() {
    [].slice.call(document.querySelectorAll('form[action$="/search"] input[name="q"]')).forEach(armar);
  }
  // Se arma al primer foco en un buscador (los del menú y del modal pueden aparecer después)
  document.addEventListener('focusin', function (e) {
    var i = e.target; if (i && i.name === 'q' && i.form && /\/search$/.test(i.form.getAttribute('action') || '')) armar(i);
  });
  if (document.readyState !== 'loading') iniciar(); else document.addEventListener('DOMContentLoaded', iniciar);
})();
